import { getRootAppWindow } from "meta/utils/getRootAppWindow";
export const refreshChartTab = (ignoreUnsavedCheck) => (dispatch, getState) => {
    let state = getState();
    const topFrame = getRootAppWindow(window);
    if (topFrame.frames[state.root.activeTabKey])
        topFrame.frames[state.root.activeTabKey].RootCommunicator.refreshActiveChild(ignoreUnsavedCheck);
};
export const openVerticalTab = (tabUniqueId, url, forceUpdate) => (dispatch, getState) => {
    let state = getState();
    let currentTabKey = state.root.activeTabKey;
    if (window.frames[currentTabKey]) {
        window.frames[currentTabKey].RootCommunicator.setActiveTabWithChildrenByUniqueId(tabUniqueId, url, forceUpdate, "normal");
    }
};
